/**
 * @file ReceiptDuplicateChoice.tsx
 * @description Повтор фасовки в приёмке: «Иван-чай 100 г уже есть в приёмке
 * (срок 03.2027) [Перейти к строке] [Новая строка — другой срок]»
 * (phase19.22, W20: одна строка = один срок = одна партия; ui-design §7).
 *
 * Раньше повторный скан молча уводил к существующей строке — вторую партию
 * с другим сроком принять было нельзя. Теперь решает кладовщик: чаще всего
 * это та же коробка (перейти), иногда — вторая партия с другим сроком.
 */

import { ArrowRight, Plus } from "lucide-react";

import { Button } from "../ui/button";
import { NoticeStrip } from "../ui/NoticeStrip";

interface Props {
  /** «Иван-чай — 100 г». */
  skuName: string;
  /** «срок 03.2027» / «без срока» — чем отличается существующая строка. */
  existingNote: string;
  onGoTo: () => void;
  onNewLine: () => void;
}

export function ReceiptDuplicateChoice({ skuName, existingNote, onGoTo, onNewLine }: Props) {
  return (
    <NoticeStrip tone="info">
      <div className="flex flex-col gap-2">
        <span>
          {skuName} уже есть в приёмке ({existingNote}).
        </span>
        {/* В боковой панели (от 1024) — всегда столбиком: в ряд вторая кнопка
            уезжала за правый край на 1280 (дефект приёмки 2026-10-02). Высота
            — стандарт темы (SC44), длинная подпись переносится, а не режется. */}
        <div className="flex flex-col gap-2 sm:flex-row lg:flex-col">
          <Button variant="outline" className="h-auto min-w-0 flex-1 whitespace-normal" onClick={onGoTo}>
            <ArrowRight className="size-4 shrink-0" />
            <span className="ml-1.5">Перейти к строке</span>
          </Button>
          <Button className="h-auto min-w-0 flex-1 whitespace-normal" onClick={onNewLine}>
            <Plus className="size-4 shrink-0" />
            <span className="ml-1.5">Новая строка — другой срок</span>
          </Button>
        </div>
      </div>
    </NoticeStrip>
  );
}
